import React from 'react';
import PropTypes from 'prop-types';

const SearchBar = ({
  handleKeyDown,
  searchInputRef,
  handleSearchTerm,
  searchTerm,
  toggleSearchModal,
  close,
  search,
  placeholder
}) => (
  <div className="search__wrapper">
    <input
      onKeyDown={handleKeyDown}
      ref={searchInputRef}
      placeholder={placeholder}
      type="text"
      onChange={handleSearchTerm}
      value={searchTerm}
    />
    <span
      onClick={search}
      role="button"
      className="icon-button icon-button--search icon-button--toggle">
      <i className="material-icons">search</i>
    </span>
    {close && (
      <div className="modal__close">
        <i className="material-icons" onClick={toggleSearchModal} role="button">
          close
        </i>
      </div>
    )}
  </div>
);

SearchBar.propTypes = {
  close: PropTypes.bool,
  handleKeyDown: PropTypes.func.isRequired,
  searchInputRef: PropTypes.object,
  handleSearchTerm: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
  toggleSearchModal: PropTypes.func,
  search: PropTypes.func.isRequired,
  placeholder: PropTypes.string
};

SearchBar.defaultProps = {
  searchTerm: '',
  close: true,
  placeholder: 'Search...',
  toggleSearchModal: null,
  searchInputRef: null
};

export default SearchBar;
